/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AcademicUser,
    AcademicUserFromJSON,
    AcademicUserFromJSONTyped,
    AcademicUserToJSON,
} from './AcademicUser';
import {
    AccreditationTypeEnum,
    AccreditationTypeEnumFromJSON,
    AccreditationTypeEnumFromJSONTyped,
    AccreditationTypeEnumToJSON,
} from './AccreditationTypeEnum';
import {
    AdminBoardDecisionReport,
    AdminBoardDecisionReportFromJSON,
    AdminBoardDecisionReportFromJSONTyped,
    AdminBoardDecisionReportToJSON,
} from './AdminBoardDecisionReport';
import {
    DiplomaSupplementReport,
    DiplomaSupplementReportFromJSON,
    DiplomaSupplementReportFromJSONTyped,
    DiplomaSupplementReportToJSON,
} from './DiplomaSupplementReport';
import {
    Domain,
    DomainFromJSON,
    DomainFromJSONTyped,
    DomainToJSON,
} from './Domain';
import {
    ExternalEvaluationReport,
    ExternalEvaluationReportFromJSON,
    ExternalEvaluationReportFromJSONTyped,
    ExternalEvaluationReportToJSON,
} from './ExternalEvaluationReport';
import {
    Faculty,
    FacultyFromJSON,
    FacultyFromJSONTyped,
    FacultyToJSON,
} from './Faculty';
import {
    GeographicLocationEnum,
    GeographicLocationEnumFromJSON,
    GeographicLocationEnumFromJSONTyped,
    GeographicLocationEnumToJSON,
} from './GeographicLocationEnum';
import {
    InternalEvaluationReport,
    InternalEvaluationReportFromJSON,
    InternalEvaluationReportFromJSONTyped,
    InternalEvaluationReportToJSON,
} from './InternalEvaluationReport';
import {
    LearningCompetence,
    LearningCompetenceFromJSON,
    LearningCompetenceFromJSONTyped,
    LearningCompetenceToJSON,
} from './LearningCompetence';
import {
    MasterCategoryEnum,
    MasterCategoryEnumFromJSON,
    MasterCategoryEnumFromJSONTyped,
    MasterCategoryEnumToJSON,
} from './MasterCategoryEnum';
import {
    OtherRelevantDocumentsReport,
    OtherRelevantDocumentsReportFromJSON,
    OtherRelevantDocumentsReportFromJSONTyped,
    OtherRelevantDocumentsReportToJSON,
} from './OtherRelevantDocumentsReport';
import {
    ProgressReport,
    ProgressReportFromJSON,
    ProgressReportFromJSONTyped,
    ProgressReportToJSON,
} from './ProgressReport';
import {
    RNCISCertificateReport,
    RNCISCertificateReportFromJSON,
    RNCISCertificateReportFromJSONTyped,
    RNCISCertificateReportToJSON,
} from './RNCISCertificateReport';
import {
    RNCISFormReport,
    RNCISFormReportFromJSON,
    RNCISFormReportFromJSONTyped,
    RNCISFormReportToJSON,
} from './RNCISFormReport';
import {
    SenateDecisionReport,
    SenateDecisionReportFromJSON,
    SenateDecisionReportFromJSONTyped,
    SenateDecisionReportToJSON,
} from './SenateDecisionReport';
import {
    StakeholderConsultationProofReport,
    StakeholderConsultationProofReportFromJSON,
    StakeholderConsultationProofReportFromJSONTyped,
    StakeholderConsultationProofReportToJSON,
} from './StakeholderConsultationProofReport';
import {
    StudyCycleEnum,
    StudyCycleEnumFromJSON,
    StudyCycleEnumFromJSONTyped,
    StudyCycleEnumToJSON,
} from './StudyCycleEnum';
import {
    StudyPlan,
    StudyPlanFromJSON,
    StudyPlanFromJSONTyped,
    StudyPlanToJSON,
} from './StudyPlan';
import {
    StudyProgramLangEnum,
    StudyProgramLangEnumFromJSON,
    StudyProgramLangEnumFromJSONTyped,
    StudyProgramLangEnumToJSON,
} from './StudyProgramLangEnum';
import {
    Subject,
    SubjectFromJSON,
    SubjectFromJSONTyped,
    SubjectToJSON,
} from './Subject';
import {
    SustainabilityAnalysisReport,
    SustainabilityAnalysisReportFromJSON,
    SustainabilityAnalysisReportFromJSONTyped,
    SustainabilityAnalysisReportToJSON,
} from './SustainabilityAnalysisReport';
import {
    TeachingFormatEnum,
    TeachingFormatEnumFromJSON,
    TeachingFormatEnumFromJSONTyped,
    TeachingFormatEnumToJSON,
} from './TeachingFormatEnum';

/**
 * 
 * @export
 * @interface StudyProgram
 */
export interface StudyProgram {
    /**
     * 
     * @type {string}
     * @memberof StudyProgram
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof StudyProgram
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StudyProgram
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof StudyProgram
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StudyProgram
     */
    numberECTS?: number;
    /**
     * 
     * @type {AccreditationTypeEnum}
     * @memberof StudyProgram
     */
    accreditationType?: AccreditationTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof StudyProgram
     */
    capacity?: number;
    /**
     * 
     * @type {string}
     * @memberof StudyProgram
     */
    educaionalDomainISCED?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyProgram
     */
    codCOR?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyProgram
     */
    ocupationName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyProgram
     */
    ancNoticeNumber?: string | null;
    /**
     * 
     * @type {GeographicLocationEnum}
     * @memberof StudyProgram
     */
    geographicLocation?: GeographicLocationEnum;
    /**
     * 
     * @type {string}
     * @memberof StudyProgram
     */
    mission?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyProgram
     */
    objective?: string | null;
    /**
     * 
     * @type {TeachingFormatEnum}
     * @memberof StudyProgram
     */
    teachingFormat?: TeachingFormatEnum;
    /**
     * 
     * @type {Date}
     * @memberof StudyProgram
     */
    ancNoticeDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StudyProgram
     */
    readonly ancExpireDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StudyProgram
     */
    aracisNoticeDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StudyProgram
     */
    readonly aracisExpireDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof StudyProgram
     */
    externalEvaluationHistory?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyProgram
     */
    ancFilePath?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyProgram
     */
    aracisRequestPath?: string | null;
    /**
     * 
     * @type {Array<ExternalEvaluationReport>}
     * @memberof StudyProgram
     */
    externalEvaluations?: Array<ExternalEvaluationReport> | null;
    /**
     * 
     * @type {Array<AdminBoardDecisionReport>}
     * @memberof StudyProgram
     */
    adminBoardDecisions?: Array<AdminBoardDecisionReport> | null;
    /**
     * 
     * @type {Array<SenateDecisionReport>}
     * @memberof StudyProgram
     */
    senateDecisions?: Array<SenateDecisionReport> | null;
    /**
     * 
     * @type {Array<SustainabilityAnalysisReport>}
     * @memberof StudyProgram
     */
    sustainabilityAnalysis?: Array<SustainabilityAnalysisReport> | null;
    /**
     * 
     * @type {Array<StakeholderConsultationProofReport>}
     * @memberof StudyProgram
     */
    stakeholderConsultationProofs?: Array<StakeholderConsultationProofReport> | null;
    /**
     * 
     * @type {Array<RNCISFormReport>}
     * @memberof StudyProgram
     */
    rncisForms?: Array<RNCISFormReport> | null;
    /**
     * 
     * @type {Array<RNCISCertificateReport>}
     * @memberof StudyProgram
     */
    rncisCertificates?: Array<RNCISCertificateReport> | null;
    /**
     * 
     * @type {Array<DiplomaSupplementReport>}
     * @memberof StudyProgram
     */
    diplomaSupplements?: Array<DiplomaSupplementReport> | null;
    /**
     * 
     * @type {Array<InternalEvaluationReport>}
     * @memberof StudyProgram
     */
    internalEvaluations?: Array<InternalEvaluationReport> | null;
    /**
     * 
     * @type {Array<ProgressReport>}
     * @memberof StudyProgram
     */
    progressReports?: Array<ProgressReport> | null;
    /**
     * 
     * @type {Array<OtherRelevantDocumentsReport>}
     * @memberof StudyProgram
     */
    otherRelevantDocuments?: Array<OtherRelevantDocumentsReport> | null;
    /**
     * 
     * @type {string}
     * @memberof StudyProgram
     */
    facultyId?: string;
    /**
     * 
     * @type {Faculty}
     * @memberof StudyProgram
     */
    faculty?: Faculty;
    /**
     * 
     * @type {string}
     * @memberof StudyProgram
     */
    domainId?: string;
    /**
     * 
     * @type {Domain}
     * @memberof StudyProgram
     */
    domain?: Domain;
    /**
     * 
     * @type {StudyCycleEnum}
     * @memberof StudyProgram
     */
    studyCycle?: StudyCycleEnum;
    /**
     * 
     * @type {string}
     * @memberof StudyProgram
     */
    programSupervisor?: string | null;
    /**
     * 
     * @type {StudyProgramLangEnum}
     * @memberof StudyProgram
     */
    language?: StudyProgramLangEnum;
    /**
     * 
     * @type {MasterCategoryEnum}
     * @memberof StudyProgram
     */
    masterCategory?: MasterCategoryEnum;
    /**
     * 
     * @type {Array<Subject>}
     * @memberof StudyProgram
     */
    subjects?: Array<Subject> | null;
    /**
     * 
     * @type {Array<AcademicUser>}
     * @memberof StudyProgram
     */
    programSupervisors?: Array<AcademicUser> | null;
    /**
     * 
     * @type {Array<StudyPlan>}
     * @memberof StudyProgram
     */
    studyPlans?: Array<StudyPlan> | null;
    /**
     * 
     * @type {Array<LearningCompetence>}
     * @memberof StudyProgram
     */
    learningCompetences?: Array<LearningCompetence> | null;
    /**
     * 
     * @type {number}
     * @memberof StudyProgram
     */
    programNumber?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StudyProgram
     */
    isDualProgram?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StudyProgram
     */
    partnerName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StudyProgram
     */
    isEurAceCertified?: boolean;
}

export function StudyProgramFromJSON(json: any): StudyProgram {
    return StudyProgramFromJSONTyped(json, false);
}

export function StudyProgramFromJSONTyped(json: any, ignoreDiscriminator: boolean): StudyProgram {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'numberECTS': !exists(json, 'numberECTS') ? undefined : json['numberECTS'],
        'accreditationType': !exists(json, 'accreditationType') ? undefined : AccreditationTypeEnumFromJSON(json['accreditationType']),
        'capacity': !exists(json, 'capacity') ? undefined : json['capacity'],
        'educaionalDomainISCED': !exists(json, 'educaionalDomainISCED') ? undefined : json['educaionalDomainISCED'],
        'codCOR': !exists(json, 'codCOR') ? undefined : json['codCOR'],
        'ocupationName': !exists(json, 'ocupationName') ? undefined : json['ocupationName'],
        'ancNoticeNumber': !exists(json, 'ancNoticeNumber') ? undefined : json['ancNoticeNumber'],
        'geographicLocation': !exists(json, 'geographicLocation') ? undefined : GeographicLocationEnumFromJSON(json['geographicLocation']),
        'mission': !exists(json, 'mission') ? undefined : json['mission'],
        'objective': !exists(json, 'objective') ? undefined : json['objective'],
        'teachingFormat': !exists(json, 'teachingFormat') ? undefined : TeachingFormatEnumFromJSON(json['teachingFormat']),
        'ancNoticeDate': !exists(json, 'ancNoticeDate') ? undefined : (new Date(json['ancNoticeDate'])),
        'ancExpireDate': !exists(json, 'ancExpireDate') ? undefined : (new Date(json['ancExpireDate'])),
        'aracisNoticeDate': !exists(json, 'aracisNoticeDate') ? undefined : (new Date(json['aracisNoticeDate'])),
        'aracisExpireDate': !exists(json, 'aracisExpireDate') ? undefined : (new Date(json['aracisExpireDate'])),
        'externalEvaluationHistory': !exists(json, 'externalEvaluationHistory') ? undefined : json['externalEvaluationHistory'],
        'ancFilePath': !exists(json, 'ancFilePath') ? undefined : json['ancFilePath'],
        'aracisRequestPath': !exists(json, 'aracisRequestPath') ? undefined : json['aracisRequestPath'],
        'externalEvaluations': !exists(json, 'externalEvaluations') ? undefined : (json['externalEvaluations'] === null ? null : (json['externalEvaluations'] as Array<any>).map(ExternalEvaluationReportFromJSON)),
        'adminBoardDecisions': !exists(json, 'adminBoardDecisions') ? undefined : (json['adminBoardDecisions'] === null ? null : (json['adminBoardDecisions'] as Array<any>).map(AdminBoardDecisionReportFromJSON)),
        'senateDecisions': !exists(json, 'senateDecisions') ? undefined : (json['senateDecisions'] === null ? null : (json['senateDecisions'] as Array<any>).map(SenateDecisionReportFromJSON)),
        'sustainabilityAnalysis': !exists(json, 'sustainabilityAnalysis') ? undefined : (json['sustainabilityAnalysis'] === null ? null : (json['sustainabilityAnalysis'] as Array<any>).map(SustainabilityAnalysisReportFromJSON)),
        'stakeholderConsultationProofs': !exists(json, 'stakeholderConsultationProofs') ? undefined : (json['stakeholderConsultationProofs'] === null ? null : (json['stakeholderConsultationProofs'] as Array<any>).map(StakeholderConsultationProofReportFromJSON)),
        'rncisForms': !exists(json, 'rncisForms') ? undefined : (json['rncisForms'] === null ? null : (json['rncisForms'] as Array<any>).map(RNCISFormReportFromJSON)),
        'rncisCertificates': !exists(json, 'rncisCertificates') ? undefined : (json['rncisCertificates'] === null ? null : (json['rncisCertificates'] as Array<any>).map(RNCISCertificateReportFromJSON)),
        'diplomaSupplements': !exists(json, 'diplomaSupplements') ? undefined : (json['diplomaSupplements'] === null ? null : (json['diplomaSupplements'] as Array<any>).map(DiplomaSupplementReportFromJSON)),
        'internalEvaluations': !exists(json, 'internalEvaluations') ? undefined : (json['internalEvaluations'] === null ? null : (json['internalEvaluations'] as Array<any>).map(InternalEvaluationReportFromJSON)),
        'progressReports': !exists(json, 'progressReports') ? undefined : (json['progressReports'] === null ? null : (json['progressReports'] as Array<any>).map(ProgressReportFromJSON)),
        'otherRelevantDocuments': !exists(json, 'otherRelevantDocuments') ? undefined : (json['otherRelevantDocuments'] === null ? null : (json['otherRelevantDocuments'] as Array<any>).map(OtherRelevantDocumentsReportFromJSON)),
        'facultyId': !exists(json, 'facultyId') ? undefined : json['facultyId'],
        'faculty': !exists(json, 'faculty') ? undefined : FacultyFromJSON(json['faculty']),
        'domainId': !exists(json, 'domainId') ? undefined : json['domainId'],
        'domain': !exists(json, 'domain') ? undefined : DomainFromJSON(json['domain']),
        'studyCycle': !exists(json, 'studyCycle') ? undefined : StudyCycleEnumFromJSON(json['studyCycle']),
        'programSupervisor': !exists(json, 'programSupervisor') ? undefined : json['programSupervisor'],
        'language': !exists(json, 'language') ? undefined : StudyProgramLangEnumFromJSON(json['language']),
        'masterCategory': !exists(json, 'masterCategory') ? undefined : MasterCategoryEnumFromJSON(json['masterCategory']),
        'subjects': !exists(json, 'subjects') ? undefined : (json['subjects'] === null ? null : (json['subjects'] as Array<any>).map(SubjectFromJSON)),
        'programSupervisors': !exists(json, 'programSupervisors') ? undefined : (json['programSupervisors'] === null ? null : (json['programSupervisors'] as Array<any>).map(AcademicUserFromJSON)),
        'studyPlans': !exists(json, 'studyPlans') ? undefined : (json['studyPlans'] === null ? null : (json['studyPlans'] as Array<any>).map(StudyPlanFromJSON)),
        'learningCompetences': !exists(json, 'learningCompetences') ? undefined : (json['learningCompetences'] === null ? null : (json['learningCompetences'] as Array<any>).map(LearningCompetenceFromJSON)),
        'programNumber': !exists(json, 'programNumber') ? undefined : json['programNumber'],
        'isDualProgram': !exists(json, 'isDualProgram') ? undefined : json['isDualProgram'],
        'partnerName': !exists(json, 'partnerName') ? undefined : json['partnerName'],
        'isEurAceCertified': !exists(json, 'isEurAceCertified') ? undefined : json['isEurAceCertified'],
    };
}

export function StudyProgramToJSON(value?: StudyProgram | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'name': value.name,
        'numberECTS': value.numberECTS,
        'accreditationType': AccreditationTypeEnumToJSON(value.accreditationType),
        'capacity': value.capacity,
        'educaionalDomainISCED': value.educaionalDomainISCED,
        'codCOR': value.codCOR,
        'ocupationName': value.ocupationName,
        'ancNoticeNumber': value.ancNoticeNumber,
        'geographicLocation': GeographicLocationEnumToJSON(value.geographicLocation),
        'mission': value.mission,
        'objective': value.objective,
        'teachingFormat': TeachingFormatEnumToJSON(value.teachingFormat),
        'ancNoticeDate': value.ancNoticeDate === undefined ? undefined : (value.ancNoticeDate.toISOString()),
        'aracisNoticeDate': value.aracisNoticeDate === undefined ? undefined : (value.aracisNoticeDate.toISOString()),
        'externalEvaluationHistory': value.externalEvaluationHistory,
        'ancFilePath': value.ancFilePath,
        'aracisRequestPath': value.aracisRequestPath,
        'externalEvaluations': value.externalEvaluations === undefined ? undefined : (value.externalEvaluations === null ? null : (value.externalEvaluations as Array<any>).map(ExternalEvaluationReportToJSON)),
        'adminBoardDecisions': value.adminBoardDecisions === undefined ? undefined : (value.adminBoardDecisions === null ? null : (value.adminBoardDecisions as Array<any>).map(AdminBoardDecisionReportToJSON)),
        'senateDecisions': value.senateDecisions === undefined ? undefined : (value.senateDecisions === null ? null : (value.senateDecisions as Array<any>).map(SenateDecisionReportToJSON)),
        'sustainabilityAnalysis': value.sustainabilityAnalysis === undefined ? undefined : (value.sustainabilityAnalysis === null ? null : (value.sustainabilityAnalysis as Array<any>).map(SustainabilityAnalysisReportToJSON)),
        'stakeholderConsultationProofs': value.stakeholderConsultationProofs === undefined ? undefined : (value.stakeholderConsultationProofs === null ? null : (value.stakeholderConsultationProofs as Array<any>).map(StakeholderConsultationProofReportToJSON)),
        'rncisForms': value.rncisForms === undefined ? undefined : (value.rncisForms === null ? null : (value.rncisForms as Array<any>).map(RNCISFormReportToJSON)),
        'rncisCertificates': value.rncisCertificates === undefined ? undefined : (value.rncisCertificates === null ? null : (value.rncisCertificates as Array<any>).map(RNCISCertificateReportToJSON)),
        'diplomaSupplements': value.diplomaSupplements === undefined ? undefined : (value.diplomaSupplements === null ? null : (value.diplomaSupplements as Array<any>).map(DiplomaSupplementReportToJSON)),
        'internalEvaluations': value.internalEvaluations === undefined ? undefined : (value.internalEvaluations === null ? null : (value.internalEvaluations as Array<any>).map(InternalEvaluationReportToJSON)),
        'progressReports': value.progressReports === undefined ? undefined : (value.progressReports === null ? null : (value.progressReports as Array<any>).map(ProgressReportToJSON)),
        'otherRelevantDocuments': value.otherRelevantDocuments === undefined ? undefined : (value.otherRelevantDocuments === null ? null : (value.otherRelevantDocuments as Array<any>).map(OtherRelevantDocumentsReportToJSON)),
        'facultyId': value.facultyId,
        'faculty': FacultyToJSON(value.faculty),
        'domainId': value.domainId,
        'domain': DomainToJSON(value.domain),
        'studyCycle': StudyCycleEnumToJSON(value.studyCycle),
        'programSupervisor': value.programSupervisor,
        'language': StudyProgramLangEnumToJSON(value.language),
        'masterCategory': MasterCategoryEnumToJSON(value.masterCategory),
        'subjects': value.subjects === undefined ? undefined : (value.subjects === null ? null : (value.subjects as Array<any>).map(SubjectToJSON)),
        'programSupervisors': value.programSupervisors === undefined ? undefined : (value.programSupervisors === null ? null : (value.programSupervisors as Array<any>).map(AcademicUserToJSON)),
        'studyPlans': value.studyPlans === undefined ? undefined : (value.studyPlans === null ? null : (value.studyPlans as Array<any>).map(StudyPlanToJSON)),
        'learningCompetences': value.learningCompetences === undefined ? undefined : (value.learningCompetences === null ? null : (value.learningCompetences as Array<any>).map(LearningCompetenceToJSON)),
        'programNumber': value.programNumber,
        'isDualProgram': value.isDualProgram,
        'partnerName': value.partnerName,
        'isEurAceCertified': value.isEurAceCertified,
    };
}

